<template>
  <v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container fluid fill-height align-start>
        <v-row  >
          <v-col md="12" lg="12" cols="12">
            <h3 class="text-h3 text-center" style="color: #393E46;">Zonas del Evento {{evento.nombre}}</h3>
            <br />
            <h6 class="text-h6  text-center mb-4" style="color: #393E46;">Cree las diferentes Zonas que tendra su evento. ej: General, Vip, Ultra, etc. Después de eso cree entradas para esa Zona.</h6>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Zona se agrego con éxito.
            </v-alert>

            <v-alert
                :value="alerteditar"
                color="green"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Zona se edito con éxito.
            </v-alert>
            <v-dialog v-model="dialogCreaZona">
              <v-card>
                <v-card-title>
                  <h1>Necesita Crear una Zona</h1>
                </v-card-title>
                <v-card-text>

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cerrar</v-btn>
              </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table
                :headers="headers"
                :items="EventoZonas"
                sort-by="eventoNombre"
                sort-desc
                class="elevation-1"
                :search="search"
                :loading="progr"
                no-data-text="No hay datos disponibles para mostrar."
                no-results-text="No hay resultados para la búsqueda."
                loading-text="Cargando... Por favor espere."
                style="background-color: #393E46;"
            >
              <template v-slot:top>
                <v-toolbar flat >

                  <v-progress-circular
                      indeterminate
                      v-if="progr == true"
                      color="primary"
                  ></v-progress-circular>

                  <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Zona del Evento</v-btn>
                    </template>
                    <v-card color="#393E46">
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" md="12">
                              <v-text-field v-model="editedItem.zona" label="Nombre"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    color="blue"
                    class="mr-2"
                    @click="editItem(item)"
                >
                  fas fa-edit
                </v-icon>
              </template>
              <template v-slot:[`item.dactiva`]="{ item }">
                <v-switch v-model="item.activo" @click="activaEventoZona(item)" ></v-switch>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="dameEventoZonas">Cargar de Nuevo</v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col class="text-center">
            <v-btn class="warning mt-4 text-center" @click="irEntradas">Ir a Crear Entradas</v-btn>

          </v-col>
        </v-row>
        <leftmenueventos :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenueventos from '../../general/leftmenueventos';
import axios from 'axios';
import moment from "moment";
import store from "@/store";
import Cabecerabaja from "@/components/general/cabecerabaja";
import firebase from 'firebase/compat/app';

export default {
  components: {
    Cabecerabaja,
    leftmenueventos,
  },
  data: () => ({
    drawer: null,
    idnegocio: 0,
    overlay:false,
    dbreads: [
      {
        text: 'Eventos',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'EventoZonas',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
    progr: true,
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    dialog: false,
    dialogdelete: false,
    abreviado:'NN',

    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    eventoId:0,
    eventoNombre:'',
    eventoTag:'',
    EventoZonas: [],
    search: '',
    dialogCreaZona:false,
    token:'',
    editedIndex: -1,
    editedItem: {
      zona: '',
      activo: false,
      createdAt: null,
      evento: {}
    },
    defaultItem: {
      zona: '',
      activo: false,
      createdAt: null,
      evento: {}
    },
    headers: [
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'EventoZona', align: 'left',  value: 'zona'},
      { text: 'Activo', value: 'dactiva' },
    ]
  }),
  mounted (){
    if(this.cliente == null){
      this.$router.push({ name: 'creacliente' });
    }else{
      if (this.cliente.id > 0) {
        let dialogo = this.$route.params.zonas
        console.log(dialogo)
        if (dialogo) {
          this.dialogCreaZona = true
        }
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

        this.dameEventoZonas();
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      }else{
        this.$router.push({ name: 'creacliente' });

      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods : {
    dameEventoZonas(){
      this.progr = true;
      this.overlay = true;
      let urlEventoZona = 'zonas/evento/' + this.evento.id ;
      axios
          .get(urlEventoZona,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.EventoZonas = response.data;
            this.progr = false;
            this.overlay = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
            this.progr = false;
          });
    },
    editItem (item) {
      this.editedIndex = this.EventoZonas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.EventoZonas.indexOf(item);
      this.dialogdelete = true;
    },
    irEntradas(){
      store.dispatch("fetchEvento", this.evento);
      this.$router.push({name:'TicketEvento'})
    },
    activaEventoZona (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      this.editedItem.evento.fechaInicio = this.formatDatree(this.editedItem.evento.fechaInicio)
      this.editedItem.evento.fechaFinal = this.formatDatree(this.editedItem.evento.fechaFinal)
      bodyFormData2.append("data",JSON.stringify(this.editedItem));
      axios
          .post('zonas/evento/grabar',bodyFormData2).then(response => {
        console.log(response);
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      this.dialogCreaZona = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    formatDatree(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    save () {
      var bodyFormData2 = new FormData();
      if (this.editedIndex > -1) {
        Object.assign(this.EventoZonas[this.editedIndex], this.editedItem);
        this.editedItem.evento.fechaInicio = this.formatDatree(this.editedItem.evento.fechaInicio)
        this.editedItem.evento.fechaFinal = this.formatDatree(this.editedItem.evento.fechaFinal)
        bodyFormData2.append("data",JSON.stringify(this.editedItem));
        axios
            .post('zonas/evento/grabar',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
          console.log(response);
          this.alerteditar = true;
          this.editedItem = this.defaultItem;
          this.dameEventoZonas();
        })
            .catch(error => {
              this.error = "Hubo un error";
              console.log(error);
            });
      } else {
        this.editedItem.evento = this.evento
        this.editedItem.activo = true
        this.editedItem.evento.fechaInicio = this.formatDatree(this.editedItem.evento.fechaInicio)
        this.editedItem.evento.fechaFinal = this.formatDatree(this.editedItem.evento.fechaFinal)
        bodyFormData2.append("data",JSON.stringify(this.editedItem));
        axios
            .post('zonas/evento/grabar',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
          this.dameEventoZonas();
          this.alertnuevo = true;
          this.editedItem = this.defaultItem;
          console.log(response);
        })
            .catch(error => {
              this.error = "Hubo un error";
              console.log(error);
            });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Zona del Evento' : 'Editar Zona del Evento'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente",
      evento: "evento"
    })
  }
};
</script>
